/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioWaveIcon20Regular = forwardRef('MediaAudioWaveIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.75 3.125a.75.75 0 0 0-1.5 0v13.75a.75.75 0 0 0 1.5 0V3.125Z" }),
        React.createElement("path", { d: "M15.75 5.406a.75.75 0 0 0-1.5 0v9.188a.75.75 0 0 0 1.5 0V5.406Z" }),
        React.createElement("path", { d: "M18.75 8.125a.75.75 0 0 0-1.5 0v3.75a.75.75 0 0 0 1.5 0v-3.75Z" }),
        React.createElement("path", { d: "M12 6.75a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M6 5.188a.75.75 0 0 1 .75.75v8.125a.75.75 0 0 1-1.5 0V5.937a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M3.75 8.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0v-2.5Z" })));
});
